class PdpBreadcrumbs extends HTMLElement {
  connectedCallback() {
    const referrer = document.referrer
    const breadcrumbData = sessionStorage.getItem('BREADCRUMB-PLP')

    if (referrer && breadcrumbData) {
      const breadcrumb = JSON.parse(breadcrumbData)
      if (referrer.includes(breadcrumb.url)) {
        this.updateBreadcrumbLink(breadcrumb)
      }
    }
  }

  updateBreadcrumbLink(breadcrumb) {
    const breadcrumbLink = this.querySelector('[data-pdp-breadcrumb]')

    if (breadcrumbLink) {
      breadcrumbLink.classList.remove('hidden')
      breadcrumbLink.href = breadcrumb.url
      breadcrumbLink.title = breadcrumb.title

      // remove arrow icon first,
      const arrowIcon = breadcrumbLink.querySelector('svg')
      breadcrumbLink.innerHTML = breadcrumb.title

      // then append arrow icon back to keep it within link
      if (arrowIcon) {
        breadcrumbLink.appendChild(arrowIcon)
      }
    }
  }
}

customElements.define('pdp-breadcrumbs', PdpBreadcrumbs)
